import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as applicationActions from "../../../actions/application";
import { APPLICATION_CONTEXTS } from "../../../constants";
import ImageButton from "../imageButton";
import "./styles.css";

export class ImageButtonList extends Component {
  /**************
   * Properties *
   **************/

  /**
   * The component's current state.
   *
   * @property {object}  state
   * @public
   *
   **/
  state = {
    buttons: null,
    currentButton: this.props.currentButton || 0,
  };
  ARROW_DOWN = 1;
  ARROW_LEFT = -1;
  ARROW_RIGHT = 1;
  ARROW_UP = -1;

  /*********************
   * Protected methods *
   *********************/

  /**
   * Builds this component's representation of the desired button list.
   *
   * @protected
   *
   * @param {object[]}  [buttons=this.props.imageButtons]  The buttons to process.
   *
   **/
  buildImageButtons = (
    currentButton = this.state.currentButton,
    props = this.props
  ) => {
    let classes = props.customClass + (props.flexClass ? " flex-button" : null);
    const buttons = Array.from(props.imageButtons);
    this.setState({
      currentButton: currentButton,
      buttons: buttons.map((button, index) => (
        <ImageButton
          key={button.id}
          className={classes}
          {...button}
          current={index === currentButton && !props.disabled}
          disabled={props.disabled || props.unfocused || button.disabled}
          resetCurrent={this.resetCurrent}
        />
      )),
    });
  };

  findEnabledButton = (direction) => {
    let currentButton = this.state.currentButton;
    let buttons = this.props.imageButtons.slice();
    if (direction === this.ARROW_LEFT || direction === this.ARROW_UP) {
      buttons = buttons.reverse();
      currentButton = this.props.imageButtons.length - 1 - currentButton;
    }
    let foundIndex = buttons.findIndex((button, buttonIndex) => {
      const match = !button.disabled && buttonIndex > currentButton;
      return match;
    });
    foundIndex = foundIndex === -1 ? currentButton : foundIndex;
    if (direction === this.ARROW_LEFT || direction === this.ARROW_UP) {
      foundIndex = this.props.imageButtons.length - 1 - foundIndex;
    }
    return foundIndex;
  };

  handleOnKeyUp = (event) => {
    if (
      this.props.unfocused ||
      this.props.disabled ||
      this.props.context !== APPLICATION_CONTEXTS.SERVICES
    ) {
      return;
    }
    if (this.props.handleKeyUp) {
      this.props.handleKeyUp(this.state.currentButton, event.key);
    }
    let current = null;
    switch (event.key) {
      case "ArrowDown":
        current = this.findEnabledButton(this.ARROW_DOWN);
        this.buildImageButtons(current);
        break;
      case "ArrowRight":
        current = this.findEnabledButton(this.ARROW_RIGHT);
        this.buildImageButtons(current);
        break;
      case "ArrowUp":
        current = this.findEnabledButton(this.ARROW_UP);
        this.buildImageButtons(current);
        break;
      case "ArrowLeft":
        current = this.findEnabledButton(this.ARROW_LEFT);
        this.buildImageButtons(current);
        break;
      default:
    }
  };

  /*******************
   * Lifecycle hooks *
   *******************/

  /**
   * Performs various actions for component that will mount.
   *
   * This method will create the initial list of buttons.
   *
   * @protected
   *
   **/
  componentWillMount() {
    this.buildImageButtons(this.state.currentButton);
    document.addEventListener("keyup", this.handleOnKeyUp, false);
  }

  /**
   * Performs various actions for component that will unmount.
   *
   * This method will remove the listener for the `keyup` event.
   *
   * @protected
   *
   **/
  componentWillUnmount() {
    document.removeEventListener("keyup", this.handleOnKeyUp);
  }

  /**
   * Performs various actions based on the new set of properties sent to this component.
   *
   * If the imageButtons prop changes, this will kick off a new build of the buttons.
   *
   * @protected
   *
   * @param {object}  nextProps  The new set of properties for this component.
   *
   **/
  componentWillReceiveProps(nextProps) {
    if (nextProps !== this.props) {
      this.buildImageButtons(nextProps.currentButton, nextProps);
    }
  }

  /******************
   * Public methods *
   ******************/
  resetCurrent = (id) => {
    let idx = this.state.buttons.findIndex((button) => {
      return button.key === id;
    });
    this.buildImageButtons(idx);
  };

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns {React.Component}  The rendered view of the component.
   *
   **/
  render() {
    let classes = `image-button-list `;
    if (this.props.flexClass) {
      classes += this.props.flexClass;
    }
    let style = {
      top: this.props.top,
      left: this.props.left,
    };
    if (this.props.width) {
      style.width = this.props.width;
    }
    if (this.props.height) {
      style.height = this.props.height;
    }
    return (
      this.state.buttons && (
        <div className={classes} style={style}>
          {this.state.buttons}
        </div>
      )
    );
  }
}

export default connect(
  (state) => ({
    context: state.application.currentContext,
  }),
  (dispatch) => ({
    actions: bindActionCreators(
      {
        ...applicationActions,
      },
      dispatch
    ),
  })
)(ImageButtonList);
